import { EffectCallback, useEffect } from 'react';

export function useMount(effect: EffectCallback) {
  useEffect(() => {
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
